<script setup>
import AdvancedConversationManager from '@/views/apps/conversation/list/AdvancedConversationManager.vue'
import BotsController from '@/Controller/bots'

definePage({
  meta: {
    action: 'read',
    subject: 'bots',
    useBotNav: true,
  },
})

import { useRoute } from 'vue-router'

// Get the bot ID from the route params
const route = useRoute()
const botId = Number.parseInt(route.params.id)
const bot = await BotsController.getBot(botId)
</script>

<template>
  <!-- Old version of add new feedback -->
  <!--
    <FeedBack
    :bot-id="botId"
    :disable-user-question="false"
    :can-minimize="false"
    /> 
  -->
  
  <AdvancedConversationManager
    :user-id="bot.userId"
    :show-user-filter="false"
    :show-add-new = "false"
  />
</template>
